module.exports = __webpack_public_path__ + "img/Slide16.aedb415c.png";